export const CardList = [
  {
    id: 1,
    domain: "ADN",
    header: "Assurance Delivery Network (ADN)",
    body:"The team delivers end‑to‑end audit cycle support through senior execution, engagement management, and specialized account and independence services across sectors such as BCM and insurance."
   },

  {
    id: 2,
    domain: "AOA",
    header: "Assurance Operational Accelerator (AOA)",
    body: "The team leverages audit expertise to deliver structured project management, effective engagement coordination, and end‑to‑end lifecycle support, including Canvas PM, PM2, PACE, and confirmations.",
  },

  {
    id: 3,
    domain: "DID",
    header: "Data & Intelligence Delivery (DID)",
    body: "The GDS Assurance team drives innovation by leveraging advanced technologies and automation to deliver RPA, low‑code solutions, rapid proofs of concept, and streamlined ERP data transformation.",
  },
];
